var React = require('react');

function AngleEnd (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.002 14a.991.991 0 0 1-.763-.359 1.006 1.006 0 0 1 .126-1.409L7.4 8.003 2.357 3.768a1.005 1.005 0 0 1-.126-1.409.988.988 0 0 1 1.398-.127L10.5 8.003l-6.862 5.765a.986.986 0 0 1-.636.232zM13 2a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1z"}));
}

AngleEnd.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = AngleEnd;

AngleEnd.default = AngleEnd;
